import { type ReactNode } from "react";
import { useGetIdentity } from "ra-core";
import { Link, useLocation } from "react-router";
import { effectiveRole } from "../sales/roles";
import { canAccess } from "../providers/commons/canAccess";
import { routeResource } from "./workspaceNavigation";
export function RoleGate({ children }: { children: ReactNode }) {
  const { identity, isPending } = useGetIdentity();
  const { pathname } = useLocation();
  const resource = routeResource(pathname);
  if (isPending || !identity)
    return <p className="p-6">Загрузка рабочей области…</p>;
  if (
    resource &&
    !canAccess(effectiveRole(identity), {
      resource,
      action: pathname.endsWith("/create")
        ? "create"
        : pathname.endsWith("/edit") ||
            (["contacts", "companies", "sales", "deals"].includes(resource) &&
              pathname.split("/").filter(Boolean).length === 2)
          ? "edit"
          : "list",
    })
  )
    return (
      <section className="mx-auto max-w-lg px-5 py-24 text-center">
        <h1 className="text-xl font-semibold">Раздел недоступен вашей роли</h1>
        <Link className="mt-5 inline-block text-primary" to="/">
          Вернуться на главную
        </Link>
      </section>
    );
  return children;
}
